import { render, staticRenderFns } from "./ListContainer.vue?vue&type=template&id=2a8183e3&scoped=true&"
import script from "./ListContainer.vue?vue&type=script&lang=js&"
export * from "./ListContainer.vue?vue&type=script&lang=js&"
import style0 from "./ListContainer.vue?vue&type=style&index=0&id=2a8183e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8183e3",
  null
  
)

export default component.exports